import { pauseAllProgressBars, resumeAllProgressBars } from '@/modules/actions/headerLineDuration';

const ACTIVE_SLIDE_SELECTOR = '.storeeel-swiper-group-wrapper .swiper-slide-active';

const isActiveStoreeelVideo = (target) => {
  if (!(target instanceof HTMLVideoElement)) return false;
  if (!target.closest?.('.storeeel-modal')) return false;
  const activeSlide = document.querySelector(ACTIVE_SLIDE_SELECTOR);
  if (!activeSlide || !activeSlide.contains(target)) return false;
  // 画像表示中など、非表示の動画イベントでは進捗を止めない
  if (!target.classList.contains('active')) return false;
  if (target.style.display === 'none' || target.style.visibility === 'hidden' || target.style.opacity === '0') {
    return false;
  }
  return true;
};

// アクティブな動画のバッファ中は進捗バーを一時停止し、再生再開で復帰する。
export const videoBufferingAction = () => {
  if (window._storeeelVideoBufferingActionBound) return;
  window._storeeelVideoBufferingActionBound = true;

  const handlePause = (event) => {
    if (!isActiveStoreeelVideo(event.target)) return;
    pauseAllProgressBars();
  };

  const handleResume = (event) => {
    if (!isActiveStoreeelVideo(event.target)) return;
    resumeAllProgressBars();
  };

  document.addEventListener('waiting', handlePause, true);
  document.addEventListener('stalled', handlePause, true);
  document.addEventListener('pause', handlePause, true);
  document.addEventListener('playing', handleResume, true);
};
